import React from 'react'
import './TopThreeBlock.css'
import {Link} from 'react-router-dom'

export default class TopThreeBlock extends React.Component {
    constructor(props) {
        super(props)

        this.state = {}
    }

    render() {
        return (
            <div className={'container'}>
                <div className="vc_row wpb_row vc_row-fluid block-top-clinic vc_custom_1490436905264">
                    <div className="wpb_column vc_column_container vc_col-sm-12 vc_col-lg-4 vc_col-has-fill">
                        <div className="vc_column-inner vc_custom_1489206813569">
                            <div className="wpb_wrapper">
                                <div className="iw-item-info  style3  item-border-v4 item-info-content-left">
                                    <div className="item-info-content ">
                                        <h3 className="title">Qui sommes-nous?</h3>
                                        <div className="content-desc"><p className="description">STAPMEDIF est née
                                            du constat que les centres d’appels traditionnels ne sont pas en mesure
                                            d’apporter une réponse appropriée aux particularités de l’imagerie
                                            médicale. </p><Link className="item-readmore" to="/about">En
                                            savoir plus <i className="ion-chevron-right"></i></Link></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="wpb_column vc_column_container vc_col-sm-12 vc_col-lg-4">
                        <div className="vc_column-inner vc_custom_1489206837935">
                            <div className="wpb_wrapper">
                                <div className="iw-item-info  style3  item-border-v4">
                                    <div className="item-info-content item-info-content-center">

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="wpb_column vc_column_container vc_col-sm-12 vc_col-lg-4">
                        <div className="vc_column-inner vc_custom_1489206853411">
                            <div className="wpb_wrapper">
                                <div className="iw-item-info  style3  item-border-v4 item-info-content-right">
                                    <div className="item-info-content ">
                                        <h3 className="title">Nos engagements</h3>
                                        <div className="content-desc"><p className="description">Acteur engagé
                                            auprès des professionnels de l’imagerie médicale, STAPMEDIF tisse avec
                                            ses clients et partenaires un lien fort. Notre certification NF EN 15838
                                            illustre cette démarche volontariste.</p><Link className="item-readmore"
                                                                                        to="/services">En
                                            savoir plus <i className="ion-chevron-right"></i></Link></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

TopThreeBlock.propTypes = {}


// WEBPACK FOOTER //
// ./src/components/TopThreeBlock.jsx